<template>
<div class="download">
   <div class="btnbox">
     <div class="box box1" @click="down">立即下载</div>
     <div class="box box2" v-clipboard:copy="downUrl"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError">点击复制链接</div>
   </div>
   <div class="toast" v-if="toast">{{message}}</div>
  
<!--   <div class="imgWrap">
    <div class="img">
        <img src="../assets/images/new1_1.jpg" alt="">
    </div>
    <div class="img">
        <img src="../assets/images/new1_1.jpg" alt="">
    </div>
    <div class="img">
        <img src="../assets/images/new1_1.jpg" alt="">
    </div>
    <div class="img">
        <img src="../assets/images/new1_1.jpg" alt="">
    </div>
    <div class="img">
        <img src="../assets/images/new1_1.jpg" alt="">
    </div>
    <div class="img">
        <img src="../assets/images/new1_1.jpg" alt="">
    </div>
    <div class="img">
        <img src="../assets/images/new1_1.jpg" alt="">
    </div>
    <div class="img">
        <img src="../assets/images/new1_1.jpg" alt="">
    </div>
    <div class="img">
        <img src="../assets/images/new1_1.jpg" alt="">
    </div>
  </div> -->





</div>
</template>

<script>
import { Toast } from 'mint-ui'
import utils from '../assets/js/utils'
export default {
  name: 'download',
  data () {
    return{
      downUrl: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.jf.lkrj',
      message:'复制成功',
      toast: false
    }
  },
  mounted() {
    document.title="花生日记APP下载"
  },
  methods:{
    down() {
      window.location = this.downUrl
    },
    onCopy() {
      this.toast = true
      this.message = '复制成功'
      setTimeout(() =>{
        this.toast = false
      },1500)
    },
    onError() {
      this.toast = true
      this.message = '复制失败'
      setTimeout(() =>{
        this.toast = false
      },1500)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.download{
  background: #fff url("../assets/images/downloadbg.jpg") no-repeat bottom center; background-size: 100%; height: 100%; width: 100%; position: relative;
  img{width: 100%;}
  .btnbox{position: absolute; bottom: 8.5rem; left: 50%; width: 14.75rem; margin-left:-7.125rem; }
  .box{ height: 1.75rem; line-height: 1.75rem; text-align: center; font-size: 0.85rem; border-radius: 0.875rem; font-size: 0.85rem; margin-bottom: 1.0rem;}
  .box1{background-color: #f42f19; color: #fff; -moz-box-shadow: -0.25rem 0.25rem -1rem #fdd5d1;box-shadow: -0.25rem 0.25rem 1rem #fdd5d1;}
  .box2{border:1px solid #f42f19; color: #f42f19;}
  .toast{position: fixed; bottom:50%; left: 50%; background-color: rgba(0,0,0,.7); color: #fff; height: 1.5rem;line-height: 1.5rem; text-align: center;  width: 5rem; margin-left: -2.5rem;}
}

// .imgWrap{
//   display: flex;
//   flex-flow: row wrap;
//   align-content: flex-start;
//   .img{
//      flex: 0 0 33.33%;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/download.vue